import { render } from "./SwiperBannerHp.vue?vue&type=template&id=96ec580c"
import script from "./SwiperBannerHp.vue?vue&type=script&lang=js"
export * from "./SwiperBannerHp.vue?vue&type=script&lang=js"

import "./SwiperBannerHp.vue?vue&type=style&index=0&id=96ec580c&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__